module.exports = __webpack_public_path__ + "audio/3db4a8436fb9c7d7fcc024f04606a683.mp3";